import React from 'react';
import { motion } from 'framer-motion';
import { useTexts } from '../../../hooks/useTexts';
import './About.css';

const stats = (t) => [
  t.stats.projects,
  t.stats.views,
  t.stats.years,
];

export default function About() {
  const t = useTexts();

  return (
    <section className="about-stats">
      {stats(t).map((s, i) => (
        <motion.div
          key={i}
          className="stat-item"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: i * 0.1 }}
        >
          <div className="stat-num">{s.num}</div>
          <div className="stat-label">{s.label}</div>
        </motion.div>
      ))}
    </section>
  );
}
